import { PersistConfig } from "redux-persist";
import storage from 'redux-persist/lib/storage';

const persistConfig: PersistConfig<any> = {
  key: 'root',
  storage: storage,
  blacklist: ['dynamic'], // Do not persist the dynamic slice at all
};

export default persistConfig;